import type { MfaChallenge, MfaFactor, MfaProvider, SsoIdentity, TotpEnrollmentInfo } from './AuthProvider'

export function unsupported(operation: string): Error {
  return new Error(`${operation} is not supported by this auth provider`)
}

/**
 * The second factor of a provider whose prompts the app never shows: Keycloak asks
 * for it on its own login pages, and an impersonated session has none of its own.
 * So the app never raises or resolves a challenge, and enrolment happens elsewhere.
 */
export class NoInAppMfa implements MfaProvider {
  async isMfaEnabled(): Promise<boolean> {
    return false
  }

  async getEnrolledFactors(): Promise<MfaFactor[]> {
    return []
  }

  async startTotpEnrollment(): Promise<TotpEnrollmentInfo> {
    throw unsupported('TOTP enrolment in the app')
  }

  async completeTotpEnrollment(): Promise<void> {
    throw unsupported('TOTP enrolment in the app')
  }

  clearPendingEnrollment(): void {}

  async unenrollAllFactors(): Promise<void> {
    throw unsupported('Removing second factors in the app')
  }

  isMfaRequiredError(): boolean {
    return false
  }

  getMfaResolver(): MfaChallenge {
    throw unsupported('An in-app MFA challenge')
  }

  getMfaRequiredIdentity(): SsoIdentity {
    throw unsupported('An in-app MFA challenge')
  }

  async handleTotpChallenge(): Promise<void> {
    throw unsupported('An in-app MFA challenge')
  }

  isRecentLoginRequiredError(): boolean {
    return false
  }

  async reauthenticateWithPassword(): Promise<void> {
    throw unsupported('Re-authentication in the app')
  }

  async reauthenticateWithGoogle(): Promise<void> {
    throw unsupported('Re-authentication in the app')
  }

  async reauthenticateWithMicrosoft(): Promise<void> {
    throw unsupported('Re-authentication in the app')
  }

  getCurrentAuthProvider(): string | null {
    return null
  }
}
